export const READINGS_COLLECTION = 'Readings';
export const LEGACY_RESULTS_COLLECTION = 'Results';

const isTimestampObject = (value) => Boolean(value && typeof value.seconds === 'number');

export const timestampToDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) return value;

  if (isTimestampObject(value)) {
    return new Date(value.seconds * 1000);
  }

  if (typeof value.toDate === 'function') {
    return value.toDate();
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
};

export const timestampToMillis = (value) => {
  const date = timestampToDate(value);
  return date ? date.getTime() : null;
};

export const getReadingTimestamp = (reading = {}) => (
  reading.timestamp
  || reading.timeStamp
  || reading.deviceTimestamp
  || reading.receivedAt
  || reading.dateCreated
  || reading.created
  || null
);

export const getReadingValues = (reading = {}) => {
  if (reading.readings && typeof reading.readings === 'object') {
    return reading.readings;
  }

  if (reading.body && typeof reading.body === 'object') {
    return reading.body;
  }

  return reading;
};

export const getReadingValue = (reading = {}, key) => {
  if (!key) return undefined;

  const values = getReadingValues(reading);
  if (values && Object.prototype.hasOwnProperty.call(values, key)) {
    return values[key];
  }

  if (Object.prototype.hasOwnProperty.call(reading, key)) {
    return reading[key];
  }

  return undefined;
};

export const getBatteryVoltage = (reading = {}) => {
  const candidates = [
    'batteryVoltage',
    'battery.voltage',
    'battery',
    'Battery',
    'voltage',
  ];

  for (const candidate of candidates) {
    const value = getReadingValue(reading, candidate);
    if (value !== undefined && value !== null && value !== '') return value;
  }

  return undefined;
};

export const formatReadingDate = (reading = {}, locale = 'en-AU') => {
  const date = timestampToDate(getReadingTimestamp(reading));
  return date ? date.toLocaleString(locale) : '';
};

export const getLastDeviceTimestamp = (device = {}) => (
  device.lastTimestamp
  || device.lasttimeStamp
  || device.lastReadingTimestamp
  || device.lastResultTimestamp
  || null
);
